import React, { useContext } from 'react';
import { SettingsContext } from '../context/SettingsContext';
import { Typography, TextField, RadioGroup, FormControlLabel, Radio, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Box } from '@mui/material';
import ColoredSwitch from '../components/ColoredSwitch';
import { useTranslation } from '../context/TranslationContext';
import { Info as InfoIcon, Brightness4 as Brightness4Icon, AttachMoney as AttachMoneyIcon, Language as LanguageIcon, BarChart as BarChartIcon } from '@mui/icons-material';

const Settings: React.FC = () => {
  const { showFileInfos, toggleShowFileInfos, darkMode, toggleDarkMode, currency, setCurrency, showCurrencySymbol, toggleShowCurrencySymbol, language, setLanguage, showAdvancedMetrics, toggleShowAdvancedMetrics } = useContext(SettingsContext);
  const { t } = useTranslation();

  const handleCurrencyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrency(event.target.value);
    localStorage.setItem('currency', event.target.value);
  };

  const handleLanguageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLanguage(event.target.value);
    localStorage.setItem('language', event.target.value);
  };

  return (
    <Paper elevation={3} style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>{t("Settings")}</Typography>
      <TableContainer>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell style={{ width: '500px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <InfoIcon style={{ marginRight: '10px' }} />
                  <Typography>{t("Show file info on import page")}</Typography>
                </div>
              </TableCell>
              <TableCell>
                <ColoredSwitch checked={showFileInfos} onChange={toggleShowFileInfos} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ width: '500px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Brightness4Icon style={{ marginRight: '10px' }} />
                  <Typography>{t("Dark Mode")}</Typography>
                </div>
              </TableCell>
              <TableCell>
                <ColoredSwitch checked={darkMode} onChange={toggleDarkMode} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ width: '500px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <AttachMoneyIcon style={{ marginRight: '10px' }} />
                  <Typography>{t("Show Currency Symbol")}</Typography>
                </div>
              </TableCell>
              <TableCell>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <ColoredSwitch checked={showCurrencySymbol} onChange={toggleShowCurrencySymbol} />
                  {showCurrencySymbol && (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                      <Typography variant="body2" style={{ marginRight: '5px' }}>{t("Symbol")}:</Typography>
                      <TextField size='small' value={currency} onChange={handleCurrencyChange} style={{ width: '100px' }} />
                    </div>
                  )}
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ width: '500px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LanguageIcon style={{ marginRight: '10px' }} />
                  <Typography>{t("Language")}</Typography>
                </div>
              </TableCell>
              <TableCell>
                <RadioGroup value={language} onChange={handleLanguageChange}>
                  <FormControlLabel value="en" control={<Radio />} label="English" />
                  <FormControlLabel value="de" control={<Radio />} label="Deutsch" />
                  <FormControlLabel value="fr" control={<Radio />} label="Français" />
                  <FormControlLabel value="es" control={<Radio />} label="Español" />
                </RadioGroup>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ width: '500px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <BarChartIcon style={{ marginRight: '10px' }} />
                  <Typography>{t("Show Advanced Metrics")}</Typography>
                </div>
              </TableCell>
              <TableCell>
                <ColoredSwitch checked={showAdvancedMetrics} onChange={toggleShowAdvancedMetrics} />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
        <Box display="flex" justifyContent="flex-end" alignItems="flex-end" mt={2}>
        <Typography variant="subtitle2">IQmulator v0.1.260</Typography>
      </Box>
    </Paper>
  );
}

export default Settings;
